import React from "react";

import NavbarIn from "./NavbarIn";
import SessionTimer from "./SessionTimer";
import "./styles/Layout.css";

function LayoutIn(props) {
  return (
    <div className="app-shell">
      <SessionTimer />
      <NavbarIn />
      <main className="app-shell__main">{props.children}</main>
    </div>
  );
}


export default (LayoutIn);
